import { Component, OnInit, AfterContentInit, Input } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

import { AuthService } from '../../../services/auth.service';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { User } from '../../../models';

@Component({
  //selector: 'sn-usc-home',
  templateUrl: './usc-home.component.html',
  styleUrls: ['../usc-store.component.css', './usc-home.component.css']
})
export class UscHomeComponent implements OnInit {
  public view:string = this.uscStoreService.view_home;

  public url: SafeResourceUrl;
  protected target_url: string = '/pages/Dashboard.aspx?src=usc';
  protected user: User;
  public display_class: string = 'hide';  
  public loading_class: string = 'show msg';

  constructor(
    private authService: AuthService,
    private uscStoreService: UscStoreService
  ) { 
  }

  ngOnInit() {
    this.url = "#";
    this.authService.authenticatedUser.subscribe(
      user => {
        this.user = user;
        if (this.user && this.user.username) {
          this.url = this.uscStoreService.getSalesNOWSanitizedUrl(this.user, this.target_url, true);
        }
      }
    )
  }

  onload(obj) {
    let src:string = obj.target.src;
    // if (src.indexOf('login.aspx') >= 0) {
    //   //this.url = this.uscStoreService.getSalesNOWSanitizedUrl(this.user, this.target_url, false);
    // } else 
    if (src.indexOf(this.target_url) >= 0) {
      this.display_class = "show";
      this.loading_class = "hide msg";
      if (obj.target.contentWindow.top) {
        //obj.target.style.height = obj.target.contentWindow.window.top.document.body.offsetHeight * 4 + 'px';
        obj.target.style.height = '2000em';
        window.scrollTo(0, 0);
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-home/usc-home.component.ts